import DOMPurify from 'dompurify'

const ALLOWED_TAGS = [
  'p', 'strong', 'em', 'h2', 'ul', 'ol', 'li', 'br',
  'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td', 'colgroup', 'col',
]

const ALLOWED_ATTR = [
  'colspan',
  'rowspan',
  'colwidth',
  'data-background-color',
  'data-vertical-align',
  'data-width-percent',
  'style',
]

// The editor only ever writes free-form `style` onto table cells — background/text
// color and vertical-align (see CustomTableCell.ts). Restricting it to
// td/th here (rather than allowing it on every ALLOWED_TAGS element)
// keeps arbitrary inline CSS out of text content.
const STYLE_ALLOWED_TAG_NAMES = new Set(['TD', 'TH'])

// <col> is the one exception: TipTap stores a table's column widths as
// `style="width: 180px"` there, and nothing else. Allowing that single
// declaration through — rather than `style` as a whole — keeps the widths
// without reopening the element to arbitrary CSS. Dropping them outright is
// what made every table render with equal columns downstream; see
// normalizeTableColumnWidths in @team-milva/lab-pdfs, which reads them.
const COL_WIDTH_STYLE = /^\s*width\s*:\s*\d+(?:\.\d+)?(?:px|%)\s*;?\s*$/i

DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
  if (data.attrName !== 'style') return
  if (STYLE_ALLOWED_TAG_NAMES.has(node.tagName)) return
  if (node.tagName === 'COL' && COL_WIDTH_STYLE.test(data.attrValue)) return

  data.keepAttr = false
})

export function sanitizeRichText(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
  })
}
